import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=b99c5888&"
import script from "./Choose.vue?vue&type=script&lang=js&"
export * from "./Choose.vue?vue&type=script&lang=js&"
import style0 from "./Choose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports